import { FontType, TextAlign } from '@modusign/react-signing/types';

import textAlignEnumToCSSProperty from '@app/features/apply-react-signing/components/FieldRenderer/libs/textAlignEnumToCSSProperty';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import TransformTextStyle from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder/TransformTextStyle';

export const STANDARD_FONT_POINT = 14;

export function useTransformTextStyle({
  fontSize,
  scale,
  size,
  fontFamily,
  textAlign,
}: {
  fontSize: number;
  scale: number;
  size: AbsoluteSize;
  textAlign: TextAlign;
  fontFamily?: FontType;
}) {
  const transformScale = (fontSize / STANDARD_FONT_POINT) * scale;
  const reverseScaleWidth = size.width / transformScale;

  const transformTextStyle: Partial<TransformTextStyle> = {
    fontFamily,
    fontSize: STANDARD_FONT_POINT,
    fontWeight: 400,
    lineHeight: 1,
    textAlign: textAlignEnumToCSSProperty(textAlign),
    transform: `scale(${transformScale})`,
    transformOrigin: 'left top',
    width: reverseScaleWidth,
    wordBreak: 'break-all',
  };

  return {
    transformTextStyle,
  };
}
